/** CloudFront in front of `cricket8-web-content` (same distribution as `CDN_ENDPOINT`). */
export const DEFAULT_SPORT_IMAGES_CDN = "https://dyatkw7msrzcb.cloudfront.net";

/**
 * Public base URL for a sport-image S3 prefix (`Football/Team Logos`, …).
 * Prefers an explicit env override, else `CDN_ENDPOINT`, else the production CDN.
 */
export function sportImagePublicBase(
  s3Prefix: string,
  envOverride?: string | undefined
): string {
  const trimmedOverride = String(envOverride || "").trim();
  if (trimmedOverride) return trimmedOverride.replace(/\/?$/, "/");

  const cdn = String(process.env.CDN_ENDPOINT || DEFAULT_SPORT_IMAGES_CDN)
    .trim()
    .replace(/\/$/, "");
  const encodedPrefix = s3Prefix
    .replace(/^\/+|\/+$/g, "")
    .split("/")
    .map(encodeURIComponent)
    .join("/");
  return `${cdn}/${encodedPrefix}/`;
}
